import { localized } from '@platform/core/lib/localized';
import type { IRecordTypeDefinition, Lang } from '@platform/core/types';
import { moduleBundle } from '@platform/i18n';

/**
 * Власний підпис створення запису типу (прототип v4 CREATE_UK / EN_SING: «акаунт», «члена партії»; «account»): рядок пакета модуля
 * `entities.<тип>.createLabel` мовою `lang`, інакше `createLabel` визначення; немає (спроєктовані типи) — undefined, тоді createLabel бере
 * знахідний відмінок назви однини.
 */
export function ownCreateLabel(lang: Lang, moduleKey: string, rt: IRecordTypeDefinition): string | undefined {
  const entity = moduleBundle(lang, moduleKey)?.entities?.[rt.key] as { createLabel?: unknown } | undefined;
  const own = typeof entity?.createLabel === 'string' ? entity.createLabel.trim() : '';
  return own || localized(rt.createLabel, lang).trim() || undefined;
}
